import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { MenuService } from '../../../services/menu.service';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'brt-tag-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, AutoCompleteModule],
  templateUrl: './tag-selector.component.html',
  styleUrl: './tag-selector.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagSelectorComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TagSelectorComponent),
      multi: true
    }
  ]
})
export class TagSelectorComponent {
  constructor(private menuService: MenuService) { }

  @Input({ required: true }) businessId: string;
  @Input() canAdd = false;
  @Input() required: boolean;

  value: string[];
  writeValue(value: any) {
    this.value = value || [];
  }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any) => { };
  onTouched = () => { };
  validate(control: AbstractControl): ValidationErrors | null {
    return this.required && !this.value?.length ? { required: true } : null;
  }

  _tags: string[] = [];
  query: string;
  get tags() {
    return [this.canAdd ? this.query : null, ...this._tags]
      .filter(_ => _ && (!this.query || _.toLocaleLowerCase().includes(this.query.toLocaleLowerCase())));
  }
  async ngOnInit() {
    if (!this.businessId) return;
    this._tags = await this.menuService.loadTags(this.businessId) || [];
  }
}
